module.exports = __webpack_public_path__ + "static/media/img_2.f9b45826.png";